import gsap from 'gsap'

export default class ServiceCardHover {
	constructor() {
		this.abortController = new AbortController()
		this.timelines = []

		this.#init()
	}

	#init() {
		document.querySelectorAll('[data-service-card]').forEach(card => this.#setupCardHoverTl(card))
	}

	#setupCardHoverTl(card) {
		const expand = card.querySelector('[data-hover-expand]')
		const expandContent = card.querySelector('[data-hover-expand] > *')
		const bg = card.querySelector('[data-hover-bg')

		if (!expand || !expandContent || !bg) return

		const tl = gsap
			.timeline({ paused: true })
			.to(bg, { height: '100%', duration: 0.5, ease: 'power3.inOut' })
			.to(expand, { height: 'auto', duration: 0.4, ease: 'power2.out' }, '<=')
			.to(expandContent, { opacity: 1, duration: 0.4, ease: 'power2.out' }, '<=50%')

		card.addEventListener('mouseenter', () => tl.play(), { signal: this.abortController.signal })
		card.addEventListener('mouseleave', () => tl.reverse(), { signal: this.abortController.signal })

		this.timelines.push(tl)
	}

	destroy() {
		this.abortController?.abort()
		this.timelines.forEach(tl => tl.kill())
		this.timelines = []
	}
}
